import { render, staticRenderFns } from "./MsRecycleScroller.vue?vue&type=template&id=28e6c6dc"
import script from "./MsRecycleScroller.vue?vue&type=script&lang=js"
export * from "./MsRecycleScroller.vue?vue&type=script&lang=js"
import style0 from "./MsRecycleScroller.vue?vue&type=style&index=0&id=28e6c6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports